/**
 * /brandbook — Elreign brand guide (route shell).
 *
 * The whole page lives in `./brandbook-screen.tsx` and is lazy-loaded via
 * `lazyRouteComponent` (ELR-21, 21 Sep audit review — same split as
 * `onboarding/firm.tsx` → `firm-screen.tsx`): `/brandbook` is a reference page,
 * not a first-paint route, and its palette table + four sections were adding
 * to the eager entry bundle for every visitor regardless of whether they ever
 * open it.
 *
 * Routing is UNCHANGED: this file keeps the `/brandbook` route (the generated
 * `routeTree.gen.ts` imports this module's `Route` export and resolves the
 * component from it), so the route still resolves exactly where it did.
 *
 * NB: this shell deliberately does NOT re-export anything from
 * `./brandbook-screen` — a static re-export would pull the page back into the
 * eager entry bundle, defeating the split.
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/brandbook')({
  component: lazyRouteComponent(() => import('./brandbook-screen'), 'BrandbookPage'),
});
